import React from 'react';
import { useLoadScript, GoogleMap, Marker } from '@react-google-maps/api';

const libraries = ['places'];

const StoreMap = ({ lat, lng }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
  });

  if (!lat || !lng) return null;

  if (!isLoaded) {
    return (
      <div className="h-44 w-full animate-pulse rounded-md bg-slate-100 dark:bg-slate-800" />
    );
  }

  const position = { lat: Number(lat), lng: Number(lng) };

  return (
    <div className="h-44 w-full overflow-hidden rounded-md ring-1 ring-slate-200 dark:ring-slate-700">
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={position}
        zoom={15}
        options={{
          disableDefaultUI: true,
          gestureHandling: 'cooperative',
          clickableIcons: false,
          styles: [
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
          ],
        }}
      >
        <Marker position={position} />
      </GoogleMap>
    </div>
  );
};

export default StoreMap;
